import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import {Emoji} from "emoji-mart"

import authentication from "@irati/auth"
import {Hr} from "@irati/ui/src/Layout"
import {Para} from "@irati/ui/src/Labels"
import {SmallCaption} from "@irati/ui/src/Labels/Labels"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Headings"
import EmojiWithText from "@irati/ui/src/EmojiWithText"

import banner from "../../images/banner.jpg"
import {SET_EMAIL} from "../../containers/Home/GetStarted"
import CTA from "./CTA"
import LiveChat from "../LiveChat"
import HelpEmail from "../HelpEmail"
import {PaddingGrid, WhiteBackground, ElevatedCard} from "../shared"
import {
  InformationText,
  WhiteH2,
  WhiteH4,
  Flex,
  SpaceBetween,
  Small,
  StyledLink,
  BannerHeadings,
  StyledRow,
  MobileBanner,
  StyledBanner
} from "./styled"

const bannerProps = {
  backgroundPosition: "0 34%",
  bannerImg: banner,
  minHeight: "500",
  tabletMinHeight: "200",
  cutOffBottom: true
}

interface Props extends InjectIntl {
  onUpdateStep: (step: string) => void
}

class Landing extends Component<Props> {
  render() {
    const {onUpdateStep, formatMessage} = this.props
    const hasTier2Access = authentication.apps("medical.tiers.tier2")
    const name = authentication.user().firstName
    return (
      <WhiteBackground>
        <Row>
          <Col xsHidden lg={12}>
            <StyledBanner {...bannerProps}>
              <PaddingGrid>
                <SpaceBetween>
                  <BannerHeadings>
                    <WhiteH2 base><FormattedMessage id="medical.landing.heading" values={{name}} /></WhiteH2>
                    <WhiteH4 large><FormattedMessage id="medical.landing.para" /></WhiteH4>
                  </BannerHeadings>
                  <CTA attachGetStartedTooltip onClick={() => onUpdateStep(SET_EMAIL)} />
                </SpaceBetween>
              </PaddingGrid>
            </StyledBanner>
          </Col>
          <Col xs={12} smHidden mdHidden lgHidden>
            <MobileBanner {...bannerProps}>
              <PaddingGrid>
                <WhiteH2 base><FormattedMessage id="medical.landing.heading" values={{name}} /></WhiteH2>
              </PaddingGrid>
            </MobileBanner>
          </Col>
        </Row>

        <PaddingGrid>
          <StyledRow>
            <Col xs={12} smHidden mdHidden lgHidden>
              <H4><FormattedMessage id="medical.landing.para" /></H4>
              <CTA onClick={() => onUpdateStep(SET_EMAIL)} />
            </Col>
            <Col xs={12} md={8}>
              <InformationText>
                <Para large light><FormattedMessage id="medical.landing.desc.1" /></Para>
                <Para large light><FormattedMessage id="medical.landing.desc.2" /></Para>
              </InformationText>
              <Para><FormattedMessage id="medical.landing.section.one.subtitle" /></Para>
              <EmojiWithText emoji="calling" text={formatMessage({id: "medical.landing.section.one.text1"})} />
              <EmojiWithText emoji="female-doctor" text={formatMessage({id: "medical.landing.section.one.text2"})} />
              <EmojiWithText emoji="pencil" text={formatMessage({id: "medical.landing.section.one.text3"})} />
              <EmojiWithText emoji="spiral_calendar_pad" text={formatMessage({id: "medical.landing.section.one.text4"})} />
              <EmojiWithText emoji="file_folder" text={formatMessage({id: "medical.landing.section.one.text5"})} />
              {hasTier2Access &&
                <EmojiWithText
                  emoji="hospital"
                  text={formatMessage({id: "medical.landing.section.one.text6"})} />}
            </Col>
            <Col xs={12} md={4}>
              <ElevatedCard>
                <Para large><FormattedMessage id="medical.landing.contactCard.para" /></Para>
                <Flex>
                  <Emoji emoji={{id: "iphone"}} size={14} set="apple" />
                  <LiveChat />
                </Flex>
                <SmallCaption bold uppercase>
                  <FormattedMessage id="medical.landing.contactCard.linesOpenTimes.p1" />
                  <br />
                  <FormattedMessage id="medical.landing.contactCard.linesOpenTimes.p2" />
                  <br />
                  <FormattedMessage id="medical.landing.contactCard.linesOpenTimes.p3" />
                </SmallCaption>
                <Hr />
                <Flex>
                  <Emoji emoji={{id: "e-mail"}} size={14} set="apple" />
                  <HelpEmail />
                </Flex>
              </ElevatedCard>
            </Col>
          </StyledRow>
          <Row>
            <Col xs={12}>
              <Small><FormattedMessage id="medical.landing.footer.p1" /></Small>
              <Small bold><FormattedMessage id="medical.landing.footer.p2" /></Small>
              <Small flush><FormattedMessage id="medical.landing.footer.p3" />
                <StyledLink
                  inBody
                  uppercase={false}
                  href={formatMessage({id: "medical.privacyPolicy.href"})}
                  target="_blank"
                  rel="noopener noreferrer">
                  <FormattedMessage id="platform.footer.href.privacyPolicy.text" />
                </StyledLink>
              </Small>
              <Small><FormattedMessage id="medical.landing.footer.p4" />
                <StyledLink
                  inBody
                  uppercase={false}
                  href={formatMessage({id: "platform.footer.href.termsAndConditions.href"})}
                  target="_blank"
                  rel="noopener noreferrer">
                  <FormattedMessage id="platform.footer.href.termsAndConditions.text" />
                </StyledLink>
              </Small>
              <Small><FormattedMessage id="medical.landing.footer.p5" /></Small>
            </Col>
          </Row>
        </PaddingGrid>
      </WhiteBackground>
    )
  }
}

export default injectIntl(Landing)
